// src/theme.js
import { createTheme } from "@mui/material/styles";

// A "light" theme
export const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2", // your primary color
    },
    secondary: {
      main: "#dc004e", // your secondary color
    },
    background: {
      default: "#fafafa",
      paper: "#ffffff",
    },
  },
  typography: {
    fontFamily: "Arial, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none", // override default uppercase
        },
      },
    },
  },
  spacing: 4,
});

// A "dark" theme
export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#dc004e",
    },
    background: {
      default: "#121212", // The color for the page background
    },
    text: {
      primary: "#ffffff", // your main text color
      secondary: "#bdbdbd", // for subtitles, hints, etc.
    },
  },
  typography: {
    fontFamily: "Arial, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none", // override default uppercase
        },
      },
    },
  },
  spacing: 4,
});
